export const stripDangerousURIs = (url: string) => {
  // very light sanitization to prevent reflective XSS using URI [PDE-4558]
  return url?.replace(/^(javascript|data):/, '');
};
